












import { isMobile } from '@/lib/utils';
import Vue from 'vue';
import DisclaimerContents from './DisclaimerContents.vue';

export default Vue.extend({
    name: 'DisclaimerModal',
    props: ['value'],
    components: { DisclaimerContents },
    data() {
        return {
            modalOpen: this.value,
        }
    },
    watch: {
        value(isOpen) {
            this.modalOpen = isOpen;
        },
        modalOpen(isOpen) {
            this.$emit('input', isOpen)
        }
    },
    methods: {
        isMobile() {
            return isMobile();
        }
    }
})
